/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../baseClient';
import { 
  GetSegmentsResponse
 } from '../types';

  //  CoreBeamerClient
class CoreBeamerClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly getSegments = (): AxiosPromise<GetSegmentsResponse> => {
        let url_ = "/api/v1/core/beamer/segments";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CoreBeamerClient
  
export const coreBeamerClient = new CoreBeamerClient(baseClientConstructorProps);
